export default __webpack_public_path__ + "static/media/Edit.cbf274ea.svg";